import { useParams } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { MessageSquare } from 'lucide-react'

export default function TeamFeedbackFilterPlaceholder() {
  const { id, filter } = useParams<{ id: string; filter: string }>()

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <header className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <MessageSquare className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-foreground">Team feedback</h1>
            <p className="text-muted-foreground">
              Team ID: <span className="font-mono">{id}</span> • View: {filter?.replace('-', ' ')}
            </p>
          </div>
        </header>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle>Migration in progress</CardTitle>
            <CardDescription>
              Charts and tables from the Next.js feedback filters are queued for migration. Continue using the legacy UI for
              the full analytics experience.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild>
              <Link to={`/dashboard/team/${id}`}>Back to team overview</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
